module.exports = __webpack_public_path__ + "img/kkb_m25.ed08bd50.jpg";